<template>
  <div class="main">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>

<style scoped>


.con {
  width: 100%;
  min-height: calc(100vh - 364px);
  /*background: #F6F6F6;*/
  background: #fff;
}

.el-backtop {
  color: #2257ab;
}
</style>
